var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DiscountType, TagType, AlgomerchTag, } from "./constants";
export var multiStopSegments = [
    {
        duration: "2h 34m",
        departureTime: "2021-01-14T13:49:00.000",
        arrivalTime: "2021-01-14T16:23:00.000",
        origin: "LGA",
        flightNumber: "629",
        destination: "MCO",
        stops: 0,
        marketingCarrier: "NK",
    },
    {
        duration: "2h 41m",
        departureTime: "2021-01-14T18:28:00.000",
        arrivalTime: "2021-01-14T20:09:00.000",
        origin: "MCO",
        flightNumber: "713",
        destination: "IAH",
        stops: 0,
        marketingCarrier: "NK",
    },
    {
        duration: "3h 18m",
        departureTime: "2021-01-14T20:59:00.000",
        arrivalTime: "2021-01-14T22:17:00.000",
        origin: "IAH",
        flightNumber: "193",
        destination: "LAS",
        stops: 0,
        marketingCarrier: "NK",
    },
    {
        duration: "1h 43m",
        departureTime: "2021-01-15T07:00:00.000",
        airlineRelatedWarnings: [],
        plusDays: 0,
        warnings: [],
        arrivalTime: "2021-01-15T08:43:00.000",
        arrivalPlusDays: 1,
        departurePlusDays: 1,
        origin: "LAS",
        flightNumber: "2079",
        destination: "SFO",
        stops: 0,
        marketingCarrier: "F9",
    },
];
export var nonstopSegments = multiStopSegments.slice(multiStopSegments.length - 1, multiStopSegments.length);
export var singleStopSegments = multiStopSegments.slice(0, 2);
export var pricingUsd = {
    base: "$100",
    tax: "$15",
    subTotal: "$115",
    fee: "$0",
    grandTotal: "$115",
    incrementalTotalDifference: "$0",
};
export var discountedPricingUsd = __assign(__assign({}, pricingUsd), { discount: {
        grandTotal: "$90",
        discountAmount: "$25",
        type: DiscountType.PRICE_DROP,
    } });
export var allTags = [
    { value: AlgomerchTag.BestFlight, type: TagType.Algomerch },
    { value: AlgomerchTag.Fastest, type: TagType.Algomerch },
    { value: AlgomerchTag.BestQuality, type: TagType.Algomerch },
    { value: AlgomerchTag.Cheapest, type: TagType.Algomerch },
];
export var pricing = {
    tripPricing: pricingUsd,
};
export var discountedPricing = {
    tripPricing: discountedPricingUsd,
};
//# sourceMappingURL=fixtures.js.map